<template>
  <div style="height: 100%; width: 100%; position: absolute; margin: 0; padding: 0">
    <div class="copyright">
      © 2019 北京互链时空数字科技有限公司<br />
      <a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration: none; color:#fff;">
        京ICP备19040347号-1
      </a>
    </div>
    <div :class="small_page ? 'leftpart1' : 'leftpart2'"></div>
    <div :class="small_page ? 'rightpart1' : 'rightpart2'">
      <div class="contents">
        <div class="elem word1">{{ type === 'yx' ? "工具箱导航" : type === 'ceo' ? 'CEO驾驶舱' : "互链网址导航" }}
        </div>
        <div v-if="showLogin">
          <div class="elem word2">登录</div>
          <el-form :model="loginForm" label-width="0" @submit.native.prevent>
            <el-form-item label="">
              <el-input v-model="loginForm.phone" size="large" name="navPhone" placeholder="请输入手机号" maxlength="11"
                style="width: 400px" />
            </el-form-item>
            <el-form-item prop="captchaCode">
              <el-input v-model="loginForm.captchaCode" maxlength="5" style="width: calc(100% - 100px);"
                placeholder="请输入验证码">
              </el-input>
              <el-image :src="url" @click="getImg" style="width: 100px; height: 40px; vertical-align: middle">
              </el-image>
            </el-form-item>
            <el-form-item label="">
              <el-input :class="['code', codeDisabled ? 'codeBtDisabled' : '']" v-model="loginForm.smscode"
                style="width: 400px" size="large" maxlength="6" placeholder="请输入短信验证码">
                <template #append>
                  <div class="code-bt" @click="getCode">{{ codeText }}</div>
                </template>
              </el-input>
            </el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="login" size="large" round
              :loading="loading" style="margin-bottom: 22px">
              登录
            </el-button>
          </el-form>
        </div>
        <div class="elem logo_div">
          <img class="logo" src="../assets/hlsk.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      small_page: true,
      rememberMe: false,
      showLogin: true,
      loading: false,
      loginForm: {
        phone: "",
        smscode: "",
        captchaCode: ""
      },
      codeDisabled: false,
      codeText: "获取短信验证码",
      platforms: [],
      selectPlatform: {},
      tempToken: "",
      type: "",
      url: ""
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.get_page();
    });
    this.get_page();
    this.getImg()
  },

  methods: {
    get_page() {
      let w = document.body.clientWidth;
      let h = document.body.clientHeight;
      let n = w / h;
      this.small_page = n < 2.3;
      this.type = localStorage.getItem('type')
    },
    login() {
      if ("" === this.loginForm.phone || "" === this.loginForm.smscode) {
        this.$message.warning({
          message: "请输入正确的手机号和验证码",
          type: "error",
        });
        return;
      }
      this.loading = true;
      const params = { phone: this.loginForm.phone, smsCode: this.loginForm.smscode }
      this.$axios.post('/account/login/smsLogin', params).then((res) => {
        if (res.data) {
          const token = res.data.data.token || "";
          localStorage.setItem('token', token)
          this.$axios.get('/account/tenant/getAllTenantList').then((tenantRes) => {
            this.loading = false;
            if (tenantRes.data) {
              const tenants = tenantRes.data.data.map((item) => {
                return item.id
              })
              if (tenants.includes(906)) {
                this.$router.replace({ name: 'main' })
              } else {
                this.$message.error("该用户没有权限")
              }
            } else {
              this.$message.error("获取权限失败");
            }
          }).catch(() => {
            this.$message.error("获取权限失败");
            this.loading = false;
          })
        } else {
          this.$message.error("登录失败");
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("登录失败");
      });
    },
    codeCountdown(wait) {
      if (wait === 0) {
        this.codeDisabled = false;
        this.codeText = "获取短信验证码";
      } else {
        this.codeDisabled = true;
        this.codeText = `${wait}s后重新获取`;
        wait--;
        setTimeout(() => {
          this.codeCountdown(wait);
        }, 1000);
      }
    },
    getCode() {
      if (this.codeDisabled) return;
      const regx = /^1[3-9][0-9]{9}$/;
      if (!regx.test(this.loginForm.phone)) {
        this.$message.warning({
          message: "请输入正确手机号",
          type: "error",
        });
        return;
      }
      if (this.loginForm.captchaCode.length !== 5) {
        this.$message.warning({
          message: '请输入正确的验证码'
        })
        return;
      }
      const params = {
        phone: this.loginForm.phone,
        simpleUUID: this.loginForm.simpleUUID,
        captchaCode: this.loginForm.captchaCode
      }
      this.$axios.post('/account/login/getsmsV2', params)
          .then((res) => {
            console.log("获取验证码", res);
            this.codeCountdown(60);
          })
          .catch(() => {
            this.$message.warning({
              message: "获取验证码失败",
              type: "error",
            });
          });
    },
    getImg() {
      this.$axios.post('/account/login/getCaptcha').then((res) => {
        this.$set(this, 'url', `data:image/png;base64,${res.data.data.img}`)
        this.$set(this.loginForm, 'simpleUUID', res.data.data.simpleUUID)
      })
    }
  },
};
</script>

<style scoped>
.code /deep/ .el-input-group__append {
  width: 135px;
  font-size: 14px;
  background-color: #409eff;
  color: #ffffff;
}

.codeBtDisabled /deep/ .el-input-group__append {
  background-color: #f5f7fa;
  color: #909399;
}

.code-bt {
  text-align: center;
}

.copyright {
  position: absolute;
  bottom: 1vh;
  left: 2vh;
  color: #ffffff;
  z-index: 1;
  font-size: 1vh;
  text-align: center;
}

.copyright_img {
  width: 1.3vh;
}

.leftpart1 {
  position: absolute;
  width: 35%;
  height: 100%;
  background: url(../assets/bg.jpg) no-repeat center center;
  background-size: 100% 100%;
  z-index: 0;
}

.rightpart1 {
  position: absolute;
  height: 100%;
  left: 35%;
  width: 65%;
  z-index: 0;
  /* pointer-events: none; */
}

.leftpart2 {
  position: absolute;
  width: 50%;
  height: 100%;
  background: url(../assets/bg_big.jpg) no-repeat center center;
  background-size: 100% 100%;
  z-index: 0;
}

.rightpart2 {
  position: absolute;
  height: 100%;
  left: 50%;
  width: 50%;
  z-index: 0;
}

.contents {
  position: relative;
  width: 40%;
  left: 30%;
  z-index: 0;

  margin-top: 20vh;
}

.elem {
  position: relative;
}

.word1 {
  color: #848181;
  font-size: 4vh;
}

.word2 {
  color: #444444;
  font-size: 5vh;
  margin-top: 2vh;
  margin-bottom: 4vh;
}

.name {
  pointer-events: auto;
}

.password {
  margin-top: 2vh;
  pointer-events: auto;
}

.el-input--large .el-input__inner {
  height: 6vh;
  line-height: 6vh;
}

.login {
  margin-top: 5vh;
  pointer-events: auto;
}

.el-button--large {
  width: 100%;
  height: 5vh;
  font-size: 2vh;
}

.word3 {
  color: #444444;
  font-size: 1.5vh;
  margin-top: 2vh;
  margin-bottom: 10vh;
  text-align: center;
}

.logo_div {
  text-align: center;
}

.logo {
  width: 15vh;
}

.word4 {
  color: #444444;
  font-size: 1.5vh;
  margin-top: 1vh;
  text-align: center;
}
</style>
